module.exports = __webpack_public_path__ + "static/media/check-box_yellow_on.a6c83864.svg";